document.querySelectorAll(".open-modal").forEach((item) => {
  item.addEventListener("click", (event) => {
    const modalId = event.target.getAttribute("data-modal-id");
    const modal = document.getElementById(modalId);
    modal.style.display = "block"; // Open the modal

    // Close the modal if the user clicks outside of it
    window.addEventListener("click", function (e) {
      if (e.target == modal) {
        modal.style.display = "none";
        form.reset(); // Reset form fields
        // Hide success message
        const successMessage = modal.querySelector(".form-status");
        if (successMessage) {
          successMessage.style.display = "none";
        }
      }
    });
  });
});

document.querySelectorAll(".close").forEach((closeButton) => {
  closeButton.addEventListener("click", function (e) {
    e.preventDefault();
    e.stopPropagation();
    const modal = closeButton.closest(".modal");
    if (modal) {
      modal.style.display = "none";
      form.reset(); // Reset form fields
      // Hide success message
      const successMessage = modal.querySelector(".form-status");
      if (successMessage) {
        successMessage.style.display = "none";
      }
    }
  });
});
